<template>
  <transition name="search-dialog-fade">
    <div v-if="visible" class="search-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭同案由判例简介信息检索弹窗" @click="handleClose" />

        <h3 class="title">同案由判例简介信息检索</h3>

        <div class="content">
          <div class="form">
            <label class="row row-name">
              <span class="label">案由名称</span>
              <input v-model.trim="formData.keyword" type="text" class="input" placeholder="请输入要搜索的案由名称关键词" />
            </label>

            <label class="row">
              <span class="label">代理律师姓名</span>
              <input v-model.trim="formData.name" type="text" class="input" placeholder="请输入代理律师姓名" />
            </label>

            <label class="row">
              <span class="label">省市归属地</span>
              <input v-model.trim="formData.province" type="text" class="input" placeholder="请输入想查询的案件省属地或直辖市名称" />
            </label>

            <div class="row row-date">
              <span class="label">时间区间</span>
              <el-date-picker v-model="formData.dateRange" class="date-picker" type="daterange" range-separator="至"
                start-placeholder="同案由判例开始时间" end-placeholder="同案由判例结束时间" value-format="yyyy-MM-dd" :clearable="true" />
            </div>

            <label class="row row-num">
              <span class="label">购买数量</span>
              <input v-model.trim="formData.quantity" type="text" class="input input-count"
                placeholder="请输入要购买的同案由判例个数" />
            </label>

            <div class="summary">
              <div class="summary-row">
                <span>单价</span>
                <span>{{ unitPriceText }}</span>
              </div>
              <div class="summary-row summary-row-spaced">
                <span>数量</span>
                <span>{{ quantityText }}</span>
              </div>
              <div class="summary-divider" />
              <div class="summary-row summary-row-total">
                <strong>总价</strong>
                <strong>{{ totalPriceText }}</strong>
              </div>
            </div>
          </div>

          <div class="action-row">
            <button type="button" class="submit" @click="handleSubmit">
              {{ submitting ? "计算中..." : "搜索内容并计算价格" }}
            </button>
            <button type="button" class="submit submit-pay" :disabled="!hasMatchedPayInfo" @click="handlePay">
              去支付
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const createDefaultFormData = () => ({
  keyword: "",
  name: "",
  province: "",
  dateRange: [],
  quantity: "",
});

export default {
  name: "SearchDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    payInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    payInfoQueryKey: {
      type: String,
      default: "",
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: createDefaultFormData(),
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.formData = createDefaultFormData();
      }
    },
  },
  computed: {
    currentQueryKey() {
      const dateRange = this.formData.dateRange || [];

      return JSON.stringify({
        keyword: this.formData.keyword || "",
        name: this.formData.name || "",
        province: this.formData.province || "",
        startDate: dateRange[0] || "",
        endDate: dateRange[1] || "",
        quantity: String(this.formData.quantity || ""),
      });
    },
    hasMatchedPayInfo() {
      return Boolean(
        this.payInfo &&
        this.payInfoQueryKey &&
        this.payInfoQueryKey === this.currentQueryKey,
      );
    },
    unitPriceText() {
      if (!this.hasMatchedPayInfo) {
        return "-";
      }

      return `¥${Number(this.payInfo.unitPrice || 0).toFixed(2)}`;
    },
    quantityText() {
      if (!this.hasMatchedPayInfo) {
        return "-";
      }

      return String(this.payInfo.quantity || "-");
    },
    totalPriceText() {
      if (!this.hasMatchedPayInfo) {
        return "-";
      }

      return `¥${Number(this.payInfo.totalPrice || 0).toFixed(2)}`;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleSubmit() {
      const dateRange = this.formData.dateRange || [];

      this.$emit("submit", {
        ...this.formData,
        startDate: dateRange[0] || "",
        endDate: dateRange[1] || "",
      });
    },
    handlePay() {
      if (!this.hasMatchedPayInfo) {
        return;
      }

      this.$emit("pay");
    },
  },
};
</script>

<style scoped>
.search-dialog {
  position: fixed;
  inset: 0;
  z-index: 1990;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 676px;
  height: 658px;
  padding: 17px 26px 33px 71px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.close {
  position: absolute;
  top: 17px;
  right: 26px;
  width: 14px;
  height: 14px;
  border: 0;
  padding: 0;
  background: url("../../../assets/home-confirm/dialogs/search-close.svg") center / 14px 14px no-repeat;
  cursor: pointer;
}

.title {
  margin: 5px 0 0;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.content {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  margin-right: 44px;
}

.form {
  width: 100%;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row+.row {
  margin-top: 22px;
}

.row-name {
  padding-left: 14px;
}

.row-date {
  align-items: flex-start;
  padding-left: 14px;
}

.row-num {
  padding-left: 14px;
}

.label {
  flex: 0 0 auto;
  color: #020202;
  font-size: 14px;
  line-height: 20px;
}

.row-date .label {
  margin-top: 14px;
}

.input {
  box-sizing: border-box;
  width: 452px;
  height: 44px;
  border: 1px solid #d4d4d4;
  border-radius: 8px;
  padding: 0 19px;
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  outline: none;
}

.input-count {
  padding-left: 16px;
}

.input::placeholder {
  color: #666666;
}

.date-picker {
  padding-left: 15px;
  box-sizing: border-box;
  width: 452px;
  height: 44px;
}

.date-picker /deep/ .el-range-editor.inner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #d4d4d4;
  border-radius: 8px;
}

.date-picker /deep/ .el-range-input {
  width: 130px;
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}

.date-picker /deep/ .el-range-input::placeholder {
  color: #666666;
}

.date-picker /deep/ .el-range-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin: 0 20px;
  color: #000000;
  font-size: 14px;
}

.date-picker /deep/ .el-range__icon {
  order: 4;
  margin-left: auto;
  margin-right: 0;
  color: #909399;
  font-size: 18px;
}

.date-picker /deep/ .close-icon {
  margin-left: 8px;
  color: #c0c4cc;
  font-size: 14px;
}

.summary {
  box-sizing: border-box;
  margin-top: 23px;
  border-radius: 8px;
  padding: 13px 17px 24px 14px;
  background: #fff3f3;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 0 4px 0 27px;
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}

.summary-row-spaced {
  margin-top: 10px;
}

.summary-divider {
  height: 1px;
  margin-top: 11px;
  background: url("../../../assets/home-confirm/dialogs/summary-divider.svg") center / 100% 1px no-repeat;
}

.summary-row-total {
  margin-top: 17px;
  padding-left: 25px;
  font-size: 16px;
  line-height: 19px;
  font-weight: 700;
}

.submit {
  align-self: center;
  width: 207px;
  height: 44px;
  margin-top: 20px;
  border: 0;
  border-radius: 8px;
  padding: 0;
  background: #d92f24;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  transition: filter 0.2s ease, transform 0.2s ease;
}

.submit:hover {
  filter: brightness(1.04);
  transform: translateY(-1px);
}

.submit[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  filter: none;
}

.action-row {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.submit-pay {
  background: #1d1d1d;
}

.search-dialog-fade-enter-active,
.search-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.search-dialog-fade-enter-active .panel,
.search-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.search-dialog-fade-enter,
.search-dialog-fade-leave-to {
  opacity: 0;
}

.search-dialog-fade-enter .panel,
.search-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
<style scoped src="./SearchDialog.mobile.css"></style>
